import React from "react";
import { Icon as IconBase, Typography } from "@mui/material";
import RpMuiToolTipBase from "@/components/muiCustom/popover/RpMuiToolTip";
import RpSvgIcon from "@/components/icons/RpSvgIcon";

const headerTooltipContent: Record<string, string> = {
  "New Start Date":
    "Your new start date defaults to the day after your current campaign ends, ensuring continuous enrollment. You can adjust this date if needed, but we recommend keeping campaigns back-to-back to avoid downtime.",
  "New End Date":
    "Select the desired date for your campaign to end. Green dates allow creative updates. Yellow dates indicate your campaign can continue, but creative updates are not available.",
  "Bulk New Start Date":
    "Your new start date defaults to the day after each location’s current campaign ends. When extending in bulk, some locations may have different end dates and won’t be eligible for the start date you’ve selected. Those locations will appear grayed out, and you can update them individually or in bulk after applying your initial bulk selections.",
  "Select Creative":
    "Your new start date defaults to the day after each location’s current campaign ends. When extending in bulk, some locations may have different end dates and won’t be eligible for the start date you’ve selected. Those locations will appear grayed out, and you can update them individually or in bulk after applying your initial bulk selections.",
};

type ExtendHeaderTooltipProps = {
  label?: string;
};

const Icon = IconBase as React.ComponentType<Record<string, any>>;
const RpMuiToolTip = RpMuiToolTipBase as React.ComponentType<
  Record<string, any>
>;

function ExtendHeaderTooltip({ label = "" }: ExtendHeaderTooltipProps) {
  return (
    <span className="d-inline-block">
      <RpMuiToolTip
        content={
          <Typography component="p" variant="caption" className="fs-10">
            {headerTooltipContent[label]}
          </Typography>
        }
      >
        <span className="d-inline-block">
          <Icon
            component={RpSvgIcon}
            name="green_info"
            fontSize="small"
            color="primary"
            style={{ width: 15, height: 15 }}
            className="ml-1 cursor-p"
          />
        </span>
      </RpMuiToolTip>
    </span>
  );
}

export default ExtendHeaderTooltip;
